import styled, { css } from 'styled-components';
import { assertBKJThemeType } from '../../providers/BKJThemeProvider/BKJThemeProvider.types.js';
export const BKJButtonWrapper = styled.button `
  ${(props) => assertBKJThemeType('BKJButton', props)};
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  font-size: 14px;
  line-height: 24px;
  width: 100%;
  align-items: center;
  border-radius: 8px;
  border: none;
  color: ${({ theme }) => theme.colors.White};
  cursor: pointer;
  display: flex;
  justify-content: center;
  max-height: 38px;
  min-height: 38px;
  outline: none;
  overflow: hidden;
  padding: 0px 30px;
  transition: background-color 100ms linear;

  ${({ minWidth }) => minWidth &&
    css `
      min-width: ${minWidth};
    `};

  ${({ width }) => width &&
    css `
      width: ${width};
    `};

  ${({ isLoading }) => isLoading &&
    css `
      pointer-events: none;
    `};

  ${({ padding }) => padding &&
    css `
      padding: ${padding};
    `};

  ${({ theme, variant }) => theme.button[variant]};
`;
//# sourceMappingURL=BKJButton.styled.js.map